import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { PrimaryButton, DefaultButton, IconButton, TooltipHost } from '@fluentui/react';
import ManageListEmbedded from '../ManageListEmbedded/ManageListEmbedded';
import Post from '../../../Data/Post';
import GeneralViewer from '../../General/GeneralViewer/GeneralViewer';
import PrintPreview from '../PrintPreview/PrintPreview';
import GetVisibleButtons from '../../../Utils/Forms/GetVisibleButtons';
import ArraySorter from '../../../Utils/General/ArraySorter';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import TopbarMenu from '../../General/TopbarMenu/TopBarMenu';
import CraftedRegionFactory from '../../Crafted/CraftedRegionFactory';
import FormHandler from '../FormHandler/FormHandler';
import { Separator } from '@fluentui/react';
import Diary from '../Diary/Diary';
import PrintBarcode from '../PrintBarcode/PrintBarcode';
import ManageRecordDates from './ManageRecordDates';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import './ManageRecord.css';
import AlertList from '../../General/AlertList/AlertList';

const ManageRecord = (props) => {

    const [rxdItemId, setRxdItemId] = useState(props.itemId);
    const [displayMode, setDisplayMode] = useState(props.action);
    const [itemId, setItemId] = useState(props.itemId);
    const [regionData, _setRegionData] = useState([]); 
    const regionDataRef = useRef(regionData);
    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [embeddedRefresh, setEmbeddedRefresh] = useState(false);
    const [rowChanged, setRowChanged] = useState(false);
    const [formStartConfig, setFormStartConfig] = useState({});
    const [listVisibility, setListVisibility] = useState(true);
    const [viewDiary, setViewDiary] = useState({display: false});
    const [viewRecord, setViewRecord] = useState({display: false});
    const [printBarcode, setPrintBarcode] = useState({display: false});
    const [alertMessages, setAlertMessages] = useState([]);
    const [reportConfiguration, setReportConfiguration] = useState([]);

    let topBarMenu = (null);
    let recordDisplay = (null);

    const errorWhenRetrievingData = (response) => {
        const errorMessage = response.data !== undefined ? response.data : response;
        updateErrorStatus({visible: true, message: errorMessage});
    }

    const setRegionData = data => {
        regionDataRef.current = data;
        _setRegionData(data);
    };

    const alertDataRetrievedSuccessfully = (data) => {
        setAlertMessages(data);
    }

    const viewDataRetrievedSuccessfully = useCallback((data, index) => {

        ManageRecordDates(data);
        var newRegionData = [...regionDataRef.current];
        newRegionData[index] = {...data};
        setRegionData(newRegionData);

        var currentView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        var resultantItemId = itemId;
        if (props.itemId !== rxdItemId) {
            setItemId(props.itemId);
            setRxdItemId(props.itemId);
            resultantItemId = props.itemId;
        }

        if (currentView !== null && currentView.Regions.length > (index + 1) && currentView.Regions[index + 1].QueryName !== '') {
            let criteria = { Name: currentView.Regions[index + 1].QueryName, Parameters: [{ Key: 'id', Value: resultantItemId }] };
            Post('query/filteredget', criteria, viewDataRetrievedSuccessfully, errorWhenRetrievingData, index + 1);

            // resetAlerts(currentView.Name);
        }
        resetAlerts(currentView.Name);

    }, [rxdItemId, itemId, props.itemId, props.recordviews, props.type]);

    useEffect(() => {
        var newView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        if (newView !== null && newView.Regions.length > 0 && newView.Regions[0].QueryName !== '') {
            const criteria = { Name: newView.Regions[0].QueryName, Parameters: [{ Key: 'id', Value: itemId }]};
            Post('query/filteredget', criteria, viewDataRetrievedSuccessfully, errorWhenRetrievingData, 0);
        }
    }, [props.recordviews, props.type, viewDataRetrievedSuccessfully, itemId]);

    const setFormConfig = (button, recordId) => {
        setFormStartConfig({
            button: button, 
            id: recordId, 
            view: props.type, 
            refresh: refreshForm,
            containerVisibility: setListVisibility,
            moveToNextItem: moveToNextFormItem,
            changeHandler: formChangeHandler
        })
    }

    const resetAlerts = (name) => {
        if (name === "specimens" || name === "cultures") {
            const criteria = { Parameters: [{ Key: 'id', Value: itemId }, { Key: 'view', Value: name }] };
            Post('alert/get', criteria, alertDataRetrievedSuccessfully, errorWhenRetrievingData);
        }
    }

    const refreshAfterReturningFromForm = () => {

        var newView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        if (newView !== null && newView.Regions.length > 0 && newView.Regions[0].QueryName !== '') {
            const criteria = { Name: newView.Regions[0].QueryName, Parameters: [{ Key: 'id', Value: itemId }]};
            Post('query/filteredget', criteria, viewDataRetrievedSuccessfully, errorWhenRetrievingData, 0);
        }

        setEmbeddedRefresh(true);
    }

    const moveToNextFormItem = () => {

    }

    const formChangeHandler = (state) => {
        if (state.key === "ReportFilter") {
            setReportConfiguration({...state});
        }
    }

    const clickButtonHandler = (button, id, recordInfo) => {
        const action = props.uievents.filter(a => a.Name === button.UIEvent);
        if (action[0].Type === 'form' ) {
            setFormConfig(button, id);
        }  else if (action[0].Type === 'diary')
        {
            setViewDiary({display: true, type: action[0].Action });
            setListVisibility(false);
        } else if (action[0].Type === 'view-record')
        {
            setViewRecord({display: true, type: action[0].Action, info: recordInfo });
            setListVisibility(false)
        } else if (action[0].Type === 'print-barcode')
        {
            setPrintBarcode({ display: true, type: action[0].Action });
        }
        else if (action[0].Type === 'printpreview')
        {
            const newDisplayMode = displayMode == "printpreview" ? "normal" : "printpreview";
            setDisplayMode(newDisplayMode)
        }
    }

    const buttonClickHandler = (button) => {
        clickButtonHandler(button, itemId);
    }

    const refreshForm = (button) => {
        if (button !== undefined && button.UIEvent !== undefined) {
            buttonClickHandler(button);
        }

        var newView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        if (button === "embeddedrefresh") {
            setEmbeddedRefresh(true);
        } else {
            if (props.updateItemRow !== undefined) {
                props.updateItemRow(itemId);
            }
    
            const queryName = newView.SingleQuery === "" ? newView.Regions[0].QueryName : newView.SingleQuery;
    
            if (newView !== null && queryName !== undefined && queryName !== "") {
                const criteria = { Name: queryName, Parameters: [{ Key: 'id', Value: itemId }] };
                Post('query/filteredget', criteria, singleViewDataRetrievedSuccessfully, errorWhenRetrievingData, { button: button });
            }
        }

        resetAlerts(newView.Name);

        if (props.onRefresh !== undefined) {
            props.onRefresh();
        }
    }

    const singleViewDataRetrievedSuccessfully = (data, extraInfo) => {
        const currentIndex = props.listData.findIndex(item => item.id === itemId || item.Id === itemId);
        props.listData[currentIndex].stateid = data.stateid;

        refreshAfterReturningFromForm();
    }

    const listClickHandler = (recordInfo) => {
        clickButtonHandler(recordInfo.button, recordInfo.id, recordInfo);
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }

    const selectPreviousItem = () => {
        let currentIndex = props.listData.findIndex(item => item.id === itemId || item.Id === itemId);
        if (currentIndex > 0) { 
            let newItemId = props.listData[--currentIndex].id;
            if (newItemId === undefined) {
                newItemId = props.listData[currentIndex].Id; 
            }
            setItemId(newItemId);
            if (props.updateItemRow !== undefined && rowChanged) {
                props.updateItemRow(newItemId);
                setRowChanged(false);
            }
        }
    }

    const selectNextItem = () => {
        let currentIndex = props.listData.findIndex(item => item.id === itemId || item.Id === itemId);
        if (currentIndex < props.listData.length - 1) {
            let newItemId = props.listData[++currentIndex].id; 
            if (newItemId === undefined) {
                newItemId = props.listData[currentIndex].Id; 
            }
            setItemId(newItemId) 
            if (props.updateItemRow !== undefined && rowChanged) {
                props.updateItemRow(newItemId);
                setRowChanged(false);
            }
        }
    }

    const onDiaryCancel = () => {
        setListVisibility(true);
        setViewDiary({display: false});
    }

    const onPrintBarcodeDone = () => {
        setPrintBarcode({display: false});
    }

    const onRecordCancel = () => {
        setViewRecord({display: false});
        setListVisibility(true);
    }

    const getListView = (listViewName) => {
        return props.views.filter((view) => {
            return view.Name === listViewName;
        })[0];
    }

    var viewConfig = props.recordviews.filter((view) => {
        return view.Name === props.type;
    })[0];

    //Custom code to exclude the relevant sections from the record view when a view configuration is not dealing with specimens
    
    let regionsToDisplay = viewConfig.Regions;
    let buttonsToDisplay = viewConfig.Buttons;
    if (props.type === "views" && props.itemId !== 23) {
        regionsToDisplay = viewConfig.Regions.filter((r) => {return r.Id === "forms"});
        buttonsToDisplay = [];
    }

    for (var region of viewConfig.Regions) {
        if (region.Type === 'listview' && region.ListViewName !== '') {
            region.ListView = getListView(region.ListViewName);
        }
    }

    var listContentCss = "managerecord-list-content";
    listContentCss += listVisibility ? "" : " app-invisible";

    let unsortedVisibleButtons;
    let currentIndex;
    if (props.listData !== undefined) {
        currentIndex = props.listData.findIndex(item => item.id === itemId || item.Id === itemId);
        const stateId = props.listData[currentIndex].stateid === undefined ? props.listData[currentIndex].StateId : props.listData[currentIndex].stateid;
        unsortedVisibleButtons = GetVisibleButtons(buttonsToDisplay, true, stateId);
    } else {
        unsortedVisibleButtons = GetVisibleButtons(buttonsToDisplay, true, 0);
    }

    let visibleButtons = unsortedVisibleButtons.sort(ArraySorter("primaryAction"));
    
    topBarMenu = <TopbarMenu
                    suppressFarItems={true}
                    showFilterIcon={false}
                    displayGridView={false}
                    buttons={visibleButtons}
                    language={props.language}
                    clickButton={buttonClickHandler}>
                </TopbarMenu>

    if (viewRecord.display) {
        recordDisplay = <ManageRecord
                            listData={viewRecord.info.listdata}
                            itemId={viewRecord.info.id}
                            stateId={viewRecord.info.stateid}
                            type={viewRecord.type}
                            buttonClickHandler={buttonClickHandler}
                            cancel={onRecordCancel}
                            recordviews = {props.recordviews}
                            views = {props.views}
                            uievents= {props.uievents}
                            language={props.language}
                            onRefresh={refreshForm}
                        >
                        </ManageRecord>
    }

    if (viewDiary.display) {
        recordDisplay = <Diary
            cancel={onDiaryCancel}
            type={viewDiary.type}
            itemId={itemId}
            stateId={props.stateId}
            onRefresh={refreshForm}
            >
        </Diary>
    }

    if (printBarcode.display) {
        recordDisplay = <PrintBarcode
            type={printBarcode.type}
            done={onPrintBarcodeDone}
            selectedRecord={props.listData[currentIndex]}
        >
        </PrintBarcode>
    }

    let latestIndex = 0;
    let stateid = 0;
    if (props.listData !== undefined) {
        latestIndex = props.listData.findIndex(item => item.id === itemId || item.Id === itemId);
        stateid = props.listData[latestIndex].stateid === undefined ? parseInt(props.listData[latestIndex].StateId) : props.listData[latestIndex].stateid;
    }

    let mainContent;
    let topAlert = (null);
    let bottomAlert = (null);
    if (displayMode == "printpreview") {
        mainContent = <div className='managerecord-content'><PrintPreview id={itemId}></PrintPreview></div>
    } else {
        topAlert = <AlertList messages={alertMessages} position="top"></AlertList>
        bottomAlert = <AlertList messages={alertMessages} position="bottom"></AlertList>
        mainContent = (
            <div className='managerecord-content'>
                {regionsToDisplay.map((region, index) => {
    
                    switch (region.Type) {
                        case "standard":
                            if (regionData[index] !== undefined && regionData[index].Sections !== undefined) {
                                return (<GeneralViewer key={region.Id} data={regionData[index]} language={props.language}></GeneralViewer>)
                            } else return (null) 
                        case "listview":
                            return (
                                <div key={region.Id}>
                                    <div>
                                        <ManageListEmbedded
                                            config={region.ListView}
                                            parentId={region.ListView.ParentId}
                                            itemId={itemId}
                                            stateid={stateid} 
                                            toggleFullScreen={false}
                                            region={index}
                                            refresh={embeddedRefresh}
                                            passive={props.passive}
                                            containerVisibility={setListVisibility}
                                            onButtonClick={listClickHandler}
                                            onRefreshDone={setEmbeddedRefresh}
                                            title={region.Title}
                                        >
                                        </ManageListEmbedded>
                                    </div>
                                </div>
                            )
                        case "crafted":
                            return(
                                <div key={region.Id}>
                                    {region.Title !== undefined && region.Title !== '' ? (
                                    <div className='managerecord-sectiontitle'>
                                        {region.Title}
                                    </div>
                                    ) : (null)}
                                    <div className='managerecord-section-table'>
                                        <CraftedRegionFactory
                                            config={region}
                                            region={index}
                                            containerVisibility={setListVisibility}
                                            refresh={embeddedRefresh}
                                            passive={props.passive}
                                            language={props.language}
                                            data={regionData}
                                            onRefresh={refreshForm}
                                            id={itemId}
                                            stateid={stateid} 
                                            onButtonClick={listClickHandler}
                                        >
                                        </CraftedRegionFactory>
                                    </div>
                                </div>
                                
                            )
                        default: return (null)
                    }
                })}
            </div>
        );
    }
    
    let titleBar = (        
        <div className='managerecord-top-buttons'>
            <div className='managerecord-titlebar-left'>
                                    <div className='managerecord-title'>
                        {viewConfig.Title}
                    </div>
            </div>
        </div>
    );

    if (props.listData !== undefined) {
        titleBar = (
            <div className='managerecord-top-buttons'>
                <div className='managerecord-titlebar-left'>
                    <div className='managerecord-button'>
                        <TooltipHost
                            content={TranslateTag("@GenExi@", props.language)}
                            id={100}
                        >
                            <IconButton
                                iconProps={{iconName: 'Back'}}
                                onClick={() => props.cancel(itemId)} 
                            />
                        </TooltipHost>
                    </div>
                    <div className='managerecord-title'>
                        {viewConfig.Title}
                    </div>
                </div>
                <div className='managerecord-right-icon-buttons'>
                    <div className='managerecord-button'>
                        <TooltipHost
                            content={TranslateTag("@GenPre@", props.language) + ' ' + viewConfig.SingleItemName}
                            id={101}
                        >
                            <IconButton
                                iconProps={{iconName: 'Previous'}}
                                onClick={()=>{selectPreviousItem()}}
                            />
                        </TooltipHost>
                    </div>
                    &nbsp;&nbsp;
                    <div className='managerecord-button'>
                        <TooltipHost
                            content={TranslateTag("@GenNex@", props.language) + ' ' + viewConfig.SingleItemName}
                            id={101}
                        >
                            <IconButton
                                iconProps={{iconName: 'Next'}}
                                onClick={()=>{selectNextItem()}}
                            />
                        </TooltipHost>
                    </div>
                </div>
            </div>
        );
    }

    let footerButtons = (
        <div className='managerecord-bottom-buttons'>
            <div className='managerecord-button'>
                <DefaultButton
                    text={TranslateTag("@GenExi@", props.language)}
                    onClick={() => props.cancel(itemId)}
                    styles={{
                        root: { border: '0px', padding: '2px', backgroundColor: '#ddd'},
                        rootHovered: { backgroundColor: '#ccc' },
                        label: {  }}}
                />
            </div>
            <div className='managerecord-right-buttons'>
                <div className='managerecord-button'>
                    <PrimaryButton
                        text={TranslateTag("@GenPre@", props.language) + ' ' + viewConfig.SingleItemName}
                        onClick={()=>{selectPreviousItem()}}
                    />
                </div>
                <div className='managerecord-button'>
                    <PrimaryButton
                        text={TranslateTag("@GenNex@", props.language) + ' ' + viewConfig.SingleItemName}
                        onClick={()=>{selectNextItem()}}
                    />
                </div>
            </div>
        </div>
    );

    // Experimental hot-keys.
    document.onkeydown = function(e) {
        switch (e.key) {
            case "ArrowLeft":
                selectPreviousItem();
                break;
            case "ArrowRight":
                selectNextItem();
                break;
            case "Escape":
                if(props.cancel !== undefined){
                    props.cancel(itemId);
                }
                break;
            default:
                break;
        }
    };


    return (
        <div className='managerecord-page'>
            {recordDisplay}
            <div className={listContentCss}>
                <div>
                    <div>
                        {titleBar}
                        {props.passive !== true ? (
                            <div>
                                {topBarMenu}
                                <div className='managerecord-topbar-separator'>
                                    <Separator></Separator>
                                </div>
                            </div>
                        ) : (null)}
                    </div>
                    {topAlert}
                    {mainContent}
                    {bottomAlert}
                </div>
                <div className='managerecord-footer'>
                    {!props.passive ? (
                        <div>
                            {footerButtons}
                        </div>
                    ) : (null)}
                </div>
            </div>
            <FormHandler startConfig={formStartConfig} refresh={refreshForm} reportConfiguration={reportConfiguration}></FormHandler>
            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message} ></ErrorMessage>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        currentView: state.display.currentView,
        views: state.config.views,
        recordviews: state.config.recordviews,
        uievents: state.config.uievents,
        forms: state.config.forms,
        pages: state.config.pages,
        lists: state.config.lists,
        language: state.config.language
    };
}

export default connect(mapStateToProps)(ManageRecord);
